module.exports = __webpack_public_path__ + "img/logotipo.b7c2cd95.png";